import React, { useState } from "react";
import {
  Card,
  Center,
  Heading,
  Flex,
  Box,
  Select,
  Grid,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Custom Components
import CustomButton from "../../components/ButtonComp";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";

const BankSchema = Yup.object().shape({
  openingbal: Yup.string().required("Opening balance is required"),
});

const AddCash = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    name: "gaswala",
    branchName: "",
    accType: "cash",
    accNo: "NA",
    ifscno: "NA",
    openingbal: "",
    id: "",
    qrCodeFile: '',
  };

 // Updated AddCash.js - Change the navigation line
const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setIsSubmitting(true);
  
      const formData = new FormData();
      formData.append("action", "create");
      formData.append("bank_name", values.name);
      formData.append("bank_branch", values.branchName);
      formData.append("ac_type", values.accType);
      formData.append("accountno", values.accNo);
      formData.append("ifsc", values.ifscno);
      formData.append("acc_ob", values.openingbal);
      formData.append("upi_id", "");
      formData.append("qr_code_image", values.qrCodeFile);
      
      const response = await fetch(baseUrl + "bank.php", {
        method: "POST",
        body: formData,
      });
  
      const result = await response.json();
      
      if (result.success) {
        toast.success(result.message);
        resetForm();
        // Changed this line - use URL parameter instead of state
        navigate("/banks?from=cash");
navigate(0);
        console.log("Navigating to /banks?from=cash"); // Debug log
        navigate("/banks?from=cash");
        console.log("Navigation completed"); // Debug log
      } else {
        toast.error(result.message);
      } 
    } catch (error) {
      toast.error(error.message || "Failed to Add Cash");
    } finally {
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };
  

  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
        mb={4}
      >
        <Heading fontSize={"xl"}>Add Cash</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title={"Back"}
          height={"30px"}
          b_color={"#000"}
          onClick={() => navigate(-1)}
        />
      </Card>

      <Formik
        initialValues={initialValues}
        validationSchema={BankSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          touched,
          errors,
          submitForm,
        }) => (
          <Form>
            <Card paddingInline={5} paddingBlock={5}>
              <Grid templateColumns={["1fr", null, "repeat(2, 1fr)"]} gap={4} mb={4}>
                {/* Agency Name - Read Only */}
                <Box>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    Agency Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <CustomSingleInput
                    name="name"
                    value="gaswale"
                    readOnly
                    borderColor="gray.300"
                    backgroundColor="#F7FAFC" 
                    fontWeight="500"
                  />
                </Box>

                {/* Agency Branch - Read Only */}
                <CustomSingleInput
  label="Agency Branch"
  name="branchName"
  value={values.branchName}
  onChange={handleChange("branchName")}
  onBlur={handleBlur("branchName")}
  placeholder="Enter branch name"
  error={touched.branchName && errors.branchName}
  required={true}
/>

              </Grid>
              
              <Grid templateColumns={["1fr", null, "repeat(2, 1fr)"]} gap={4} mb={4}>
                {/* Account Type - Fixed to Cash */}
                <Box>
                  <label style={{ fontSize: "14px", fontWeight: "500", marginBottom: "8px", display: "block" }}>
                    Account Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    name="accType"
                    value={values.accType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    borderColor="gray.300"
                  >
                    <option value="cash">Cash</option>
                  </Select>
                </Box>
                
                {/* Opening Balance - User Input */}
                <CustomSingleInput
                  label={"Opening Balance"}
                  value={values.openingbal}
                  onChange={handleChange("openingbal")}
                  onBlur={handleBlur("openingbal")}
                  placeholder={"Enter opening balance"}
                  error={touched.openingbal && errors.openingbal}
                  required={true}
                />
              </Grid>

              <Center mt={6}>
                <CustomButton
                  title={isSubmitting ? "Submitting..." : "Add Cash"}
                  onClick={submitForm}
                  disabled={isSubmitting}
                />
              </Center>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddCash;